// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c081b791","455":"f7d5888d","458":"e8142ddb"}[chunkId] + ".chunk.js";
};